import React from 'react';
import type { LabelProps } from './primitives.types';

/*
  The DOM half of a line of text.

  A span rather than a div, because a line of text is what it is; the reset undoes the parts of the
  inherited box that React Native has no equivalent of, so a Label reads the same wherever it lands.
*/
export const Label: React.FC<LabelProps> = ({ style, children }) => (
  <span
    style={{
      margin: 0,
      padding: 0,
      // RN's Text carries no inherited font; naming the family here means the app's board and the
      // web's read the same rather than the web's borrowing whatever the page was using.
      fontFamily: style.fontFamily,
      fontSize: style.fontSize,
      fontWeight: style.fontWeight,
      color: style.color,
      lineHeight: style.lineHeight === undefined ? undefined : `${style.lineHeight}px`,
      textAlign: style.textAlign,
      opacity: style.opacity,
      whiteSpace: 'nowrap',
    }}
  >
    {children}
  </span>
);
